import { z } from 'zod';
import { passwordValidator } from '../../utils/common';
import { MP_PASSWORD_REGEX } from '../../utils/constants';
export const ChangePasswordSchema = z
    .object({
    oldPassword: passwordValidator.regex(MP_PASSWORD_REGEX),
    newPassword: passwordValidator.regex(MP_PASSWORD_REGEX)
})
    .describe('Change Password object with oldPassword and newPassword');
export const UpdatePasswordSchema = z
    .object({ newPassword: passwordValidator.regex(MP_PASSWORD_REGEX) })
    .describe('Update Password object with newPassword');
export const SetForgottenPasswordSchema = z
    .object({ password: passwordValidator })
    .describe('Set Forgotten Password object with password');
//# sourceMappingURL=changePasswordSchema.js.map